module.exports = __webpack_public_path__ + "img/XL_PERSO_ETAB.05d6a130.svg";